<template>
   <div>
    <v-container>
            <v-row justify-space-between>
              <v-col>
                <v-card class="pa-8 mr-2" flat min-height="340px" height="100%">
                  <Logs />
                </v-card>
              </v-col>
            </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Logs from "@/components/Logs";

export default {
  components: {
    Logs
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
  data: () => ({
    loading: false,
  })
};
</script>

<style>
</style>